import { AlertsTooltip } from 'bank-documents/src/components/AlertsTooltip'
import { DOCUMENTS_PATH } from 'commons/constants/routes'
import { LicenseWebPageDocumentItem } from 'commons/types/DTO/bank/license'
import { CheckMark } from 'ui/components/CheckMark'
import { DateTime } from 'ui/components/DateTime'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'

export const useColumns = (
  deleteDocument: (id: number, name: string) => void,
  returnUrl: string
): TableColumn<LicenseWebPageDocumentItem>[] => [
  {
    sortable: true,
    key: 'name',
    title: 'Document Name',
    render: ({ id, name }) => (
      <Link to="/documents/$documentId" params={{ documentId: id.toString() }}>
        {name}
      </Link>
    )
  },
  {
    sortable: true,
    key: 'internal',
    title: 'Internal',
    render: ({ internal }) => (internal ? <CheckMark value rounded /> : null)
  },
  {
    sortable: true,
    key: 'frequency',
    title: 'Frequency'
  },
  {
    sortable: true,
    key: 'expirationDate',
    title: 'Expiration Date',
    render: ({ expirationDate }) => <DateTime date={expirationDate} />
  },
  {
    align: 'left',
    title: 'Alerts',
    render: ({ id, alerts }) => <AlertsTooltip id={id} alerts={alerts} />
  },
  {
    title: 'Actions',
    width: '50px',
    render: ({ id, name }) => (
      <TableActions
        items={[
          {
            type: 'edit',
            url: `${DOCUMENTS_PATH}/${id}/edit?returnUrl=${returnUrl}`
          },
          {
            type: 'delete',
            onClick: () => deleteDocument(id, name)
          }
        ]}
      />
    )
  }
]
